import { Component,OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import { UserService } from "../../services/UserService";
import Swal from "sweetalert2";
import { AppLoaderComponent } from "../../../services/app-loader/app-loader.component";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { LicenseService } from "../../services/LicenseService";
import { LicensePortalProduct } from "../../interfaces/LicenseModel";
import { ProductService } from "../../services/ProductService";

@Component({
    selector: 'home-page',
    template: require('./home-page.component.html'),
    styles: [require('./home-page.component.css')]
})
export class HomePageComponent {
    userId=0;
    IsAdmin;
    errorMessage;
    portalAccess;
    constructor(
        private router: Router,
        private adal: AdalService,
        private userService: UserService,
        private appLoader: AppLoaderService,
        private licenseService:LicenseService,
        private productService:ProductService
    ) {
        // Check Authentication
        if (!this.adal.getCachedToken()) {
            this.router.navigate(["login"]);
        }
    }
    ngOnInit(){
        this.userId = Number(localStorage.getItem('userid'))
        this.portalAccess=Number(localStorage.getItem('portalAccess'))
        this.IsAdmin=localStorage.getItem('IsAdmin')
        // this.getUserRights(this.userId)
    }
    navigateToOTA() {
        this.appLoader.open();
        this.productService.GetFirstDisplayedOTAProduct().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.router.navigate(['/app/pglayout/product-release-tab/'+data.DataObject.ProductName+'/'+data.DataObject.ProductId+'/'+data.DataObject.Code+'/'+data.DataObject.Variant+'/'+0]);
            }
            this.appLoader.close();
        })
    }
    navigateToLicensePortal() {
        let productId;
        let productName;
        this.appLoader.open();
        this.licenseService.getLicensePortalProductByProductCode(LicensePortalProduct.SmartCal360N).subscribe((data)=>{
            if(data.DataObject!=null && !data.IsError){
                productId=data.DataObject.ProductId
                productName=data.DataObject.ProductName
                this.router.navigate(['/license-portal/'+productName+'/'+productId])
            }
            this.appLoader.close()
        });
        
    }
    navigateToAdvertisement() {
        this.router.navigate(['/advertisement'])
    }
    navigateToUserManagement() {
        this.router.navigate(['/user-management/user'])
        // if (!this.IsAdmin) {
        //     Swal.fire({
        //         title: 'Access Denied',
        //         text: 'You don\'t have the rights to view this portal',
        //         confirmButtonColor: '#FFCA28',
        //         focusConfirm: false,
        //         allowEnterKey: false
        //     })
        // }
        // else {
        //     this.router.navigate(['/user-management/user'])
        // }
    }
    // getUserRights(UserId) {
    //     this.userService.getUserById(UserId).subscribe(
    //         Data => {
    //             this.IsAdmin = Data.IsAdmin;
    //         },
    //         error => {
    //             this.errorMessage = error;
    //         });
    // }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/extra-pages/HomePage/home-page.component.ts